import { Link } from "react-router-dom"

const PRIVACY_POLICY = `1. Introduction

Doggy Dynamo ("we", "us", "our") provides a personality assessment and guidance service for dog owners. This Privacy Policy explains what personal data we collect, how we use it, and the choices available to you when you use our website and app at doggydynamo.com (the "Service").

2. Who we are

Doggy Dynamo is operated for friends-and-family testing. Contact: privacy@doggydynamo.com.

3. Data we collect

Account data: email address, password (stored hashed), email verification status, and account preferences such as notification settings.

Dog profile data: your dog's name, sex, age range, breed (if provided), personality assessment answers and results, Story entries, learned facts, and optional photos you upload for personalised portraits.

Usage data: Ask Dynamo conversations, saved Ask Dynamo messages, share-card activity, subscription status, and technical logs such as IP address, browser type, and timestamps needed to operate and secure the Service.

Payment data: if you subscribe to Doggy Dynamo Plus, payment processing is handled by Stripe. We receive subscription status and limited billing metadata from Stripe; we do not store full card numbers.

4. How we use your data

We use your data to:
- provide personality assessment results, dashboards, Ask Dynamo answers, Story, portraits, email updates ("Kibbles"), and related features;
- personalise content for your dog and household;
- send service, verification, password-reset, and (where enabled) marketing or product emails;
- process subscriptions and manage entitlements;
- improve reliability, security, and product quality;
- comply with legal obligations.

Ask Dynamo uses your dog profile context and, for Plus users, selected memory features to generate responses. Do not enter sensitive personal information about yourself or others into Ask Dynamo unless you are comfortable with it being processed for this purpose.

5. Legal bases (UK / EEA users)

Where applicable, we rely on: performance of a contract (providing the Service); legitimate interests (security, product improvement, and service communications); consent (optional notifications and marketing where required); and legal obligation.

6. Sharing and processors

We use trusted service providers to host the Service, send email, process payments, generate portraits and AI responses, and deliver analytics or error monitoring. These providers process data only on our instructions and under appropriate safeguards.

We do not sell your personal data. We may disclose data if required by law or to protect the rights, safety, and security of users and the Service.

7. International transfers

If data is processed outside your country, we use appropriate safeguards such as standard contractual clauses where required.

8. Retention

We retain account and dog profile data while your account is active and for a reasonable period afterward so you can restore access or export data. Ask Dynamo messages, Story entries, photos, and export files may be retained according to product settings and backup schedules unless you delete them or request account deletion.

9. Your rights

Depending on your location, you may have rights to access, correct, delete, restrict, or object to processing of your personal data, and to data portability. You can update many details in your account settings, request a data export from the Privacy page, or delete your account from within the Service where available.

To exercise rights, contact privacy@doggydynamo.com. You may also complain to your local data protection authority.

10. Children

The Service is intended for adults. Do not create an account if you are under 16 (or the age required in your country).

11. Security

We use administrative, technical, and organisational measures appropriate to the nature of the data we hold. No online service can guarantee absolute security.

12. Changes

We may update this policy as the product evolves. Material changes will be reflected by updating the version and date below.

13. Contact

Questions about privacy: privacy@doggydynamo.com`

export function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[var(--color-surface-main)] pb-16">
      <main className="mx-auto max-w-2xl px-4 py-8">
        <p className="text-sm text-[var(--color-text-secondary)]">
          <Link to="/" className="underline">
            Doggy Dynamo
          </Link>
        </p>
        <h1 className="mt-4 text-3xl font-semibold text-[var(--color-text-primary)]">
          Privacy Policy
        </h1>
        <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
          Version 1.0 · Effective date: 3 September 2026 · Last updated: 3 September 2026
        </p>
        <div className="mt-6 whitespace-pre-line text-sm leading-relaxed text-[var(--color-text-primary)]">
          {PRIVACY_POLICY}
        </div>
      </main>
    </div>
  )
}
